import { CaseStatusModel } from './caseStatusModel';

export class AddCaseStatusModel extends CaseStatusModel {
}
